// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'Ask HP Nio',
      close: 'Close Nio Chat',
      open: 'Open Nio Chat',
      morningGreeting: "Good morning {0},",
      afternoonGreeting: "Good afternoon {0},",
      eveningGreeting: "Good evening {0},",
      morningGreetingGeneric: "Good morning,",
      afternoonGreetingGeneric: "Good afternoon,",
      eveningGreetingGeneric: "Good evening,",
      opening: "I'm Nio.  How can I help?",
      openingPrivacy: "I'm Nio.",
      pbIntro1: "Ask me about your device productivity.",
      alertBeta: "Nio is in early beta.  Answers are currently limited to Print Beat and Knowledge Zone.",
      alertDefault: "Answers are currently limited to Print Beat and Knowledge Zone.",
      intro2:  "Here are some questions that might be interesting:",
      kzIntro1: "Ask me about your concerns and I will answer with Knowledge Zone information.",
      pbSample1: "How productive was the site yesterday?",
      pbSample2: "How can I improve my productivity?",
      pbSample3: "Which press is outperforming the rest of my presses?",
      pbSample4: "Which substrate caused me the highest time lost?",
      pbSample5: "In what issue did I waste the most time last week?",
      kzSample1: "How can I reduce substrate waste while maintaining quality and cutting costs?",
      kzSample2: "Which HP Indigo press is best for efficient, color-consistent wine label printing?",
      kzSample3: "How can I optimize supplies usage to boost productivity?",
      kzSample4: "What key sustainability factors should I consider in printing?",
      kzSample5: "How do I ensure color consistency between my HP Indigo 6000 and 20K presses?",
      feedbackTitle: "Reason for your score",
      feedbackPlaceholder: "Can you explain in detail what happened?",
      fbPositive1: "Data is correct",
      fbPositive2: "Very good response",
      fbPositive3: "Very detailed",
      fbPositive4: "Answer was relevant",
      fbOther: "Other",
      fbNegative1: "The information or data is incorrect",
      fbNegative2: "The response did not address my question",
      fbNegative3: "The response was confusing or unclear",
      fbNegative4: "Answer was not relevant",
      feedbackSubmittedTitle: "Thank you for your feedback!",
      feedbackSubmittedDescription_Positive: "We're glad to hear the response was helpful!  Your feedback encourages us to keep delivering better experiences.",
      feedbackSubmittedDescription_Negative: "We apologize for any inconvenience this may have caused. Our team will review the information and work on correcting it. If you have more details about the error or additional feedback, please let us know to help us improve.",
      ask_Placeholder: "What do you want to know?",
      answerCopiedToClipboard: "Answer copied to clipboard",
      feedbackSubmitted: "Feedback submitted",
      feedbackCleared: "Feedback removed",
      newConversation: "New chat",
      chatHistory: "Chat History",
      submitQuestion: "Submit Question",
      defaultStopMessage: "Response aborted by the user.",
      stopQuestion: "Stop Generating",
      responseError: "Oops, It looks like we encountered an issue on our side.  Please try again later.  If the issue persists, please contact support.",
      responseError400: "It looks like your question has unexpected characters.  Please remove them to continue.",
      responseError429: "Whoa, slow down.  I can't keep up with that many questions.",
      like: "Like",
      dislike: "Dislike",
      copy: "Copy to clipboard",
      retry: "Retry",
      contact: "Contact us",
      contactSubject: "HP Nio Issue",
      contactQuestion: "Question: {0}",
      noConversations: "You have no conversations",
      startConversation: "Start a conversation to see your chat history here",
      today: "Today",
      yesterday: "Yesterday",
      lastWeek: "Last week",
      older: "Older",
      chatDeletePolicy: "Inactive chats are deleted after 90 days.",
      privacyNotice: "You are interacting with an AI solution.  Review the answers as they may be incomplete or inaccurate.",
      privacy1: "You are about to engage in an AI solution.  Chats may be reviewed and used to train our models.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Start chatting with HP Nio",
      deleteConversationTitle: "Delete Chat",
      conversationName: "Conversation",
      deleteConversationConfirm: "This will delete <b>{0}</b>.<br>This action cannot be undone.",
      deleteConversationSuccess: "Conversation deleted",
      deleteConversationError: "Could not delete conversation",
      renameConversationTitle: "Rename Conversation",
      renameConversationMessage: "Conversation name",
      renameConversationSuccess: "Conversation renamed",
      renameConversationError: "Could not rename conversation",
      deleteConversation: "Delete",
      renameConversation: "Rename",
    },
    apps: {
      title: "Menu",
      externalLinks: "External",
      availableApps: "Explore",
      configure: "Customize",
      showApp: "Show",
      hideApp: "Hide",
      setDefault: "Set Default Application",
      setShortcut: "Set as pinned",
      removeShortcut: "Unpin",
      showAllApps: "Show all applications",
      shortCutTooltip: "Go to {0}",
      currentAccount: "Current Organization",
      goHome: "Go Home",
      goAppHome: "Go to application start page",
      byProvider: "by {0}",
      quickFilter: "Find application...",
      allApps: "All Applications",
      recentApps: "Recent",
      externalApp: "Application external to PrintOS",
      modeSwitcher: "Dark/Light Mode",
      goProducts: "Explore more apps"
    },
    panels: {
      ai: "Ask HP Nio",
      notifications: "My Notifications",
      help: "Help and Support",
      user: "User",
      close: "Close Panel",
      moveLeft: "Move left",
      moveRight: "Move right",
      maximize: "Maximize",
      restore: "Restore",
    },
    user: {
      account: "Organization",
      returnToHP: "Return to HP Inc.",
      myOrganization: "My Organization",
      myOrganizations: "My Organizations",
      myReports: "My Reports",
      mySettings: "My Settings",
      signOut: "Sign Out",
      signInExplanation: "Sign in to HP PrintOS to see your notifications and applications.",
      signIn: "Sign In",
      RCDA: "Customer Access",
      orphanUser: "PrintOS User",
      orphanContext: "No Organizations",
      deviceUser: "PrintOS Device",
      anonymous: "Anonymous User",
      name: "Name",
      email: "Email",
      address: "Address",
      editUser: "Edit HP Account",
      viewPrivacy: "View Privacy Statement"
    },
    date: {
      fewSecondsAgo: "A few seconds ago",
      minuteAgo: "A minute ago",
      minutesAgo: "{0} minutes ago",
      hourAgo: "An hour ago",
      hoursAgo: "{0} hours ago",
      dayAgo: "A day ago",
      daysAgo: "{0} days ago",
      monthAgo: "A month ago",
      monthsAgo: "{0} months ago",
      yearAgo: "A year ago",
      yearsAgo: "{0} years ago",
    },
    help: {
      quickFilter: "Search",
      page: "Page",
      app: "Application",
      newFeatures: "New Features",
      more: "All",
      contactHP: "Contact HP",
      noTopics: "No matching help topics",
      about: "About",
      terms: "Terms of Service",
      readFile: "Document",
      stepByStepTutorial: "Tutorial",
      goLink: "Application Page",
      viewVideo: "Video",
      goToUrl: "Link",
      other: "Other",
      faq: "Frequently asked",
      new: "New topic",
      whatsNew: "What's new?",
      technicalSupport: "PrintOS Support",
      printOSFeedback: "PrintOS Feedback",
      conversationsWithHP: "Conversations with HP",
      youMayConsider: "You may consider...",
      myKzArticles: "My Knowledge Zone articles",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "HP Latex Knowledge Center articles",
    },
    notifications: {
      noNotifications: "There are no notifications",
      viewAll: "View all",
      dismiss: "Dismiss",
      dismissAll: "Dismiss All",
      subscriptions: "Settings",
    },
    marketplace: {
      title: "Marketplace",
      explore: "Explore All",
      featured: "Featured",
      slides: {
        default: {
          description: "Enhance PrintOS with premium applications, extensions, and connectors"
        },
        oee: {
          title: "Print Beat OEE",
          description: "Drive operational excellence with near real-time data driven insights",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "Access to Indigo Print Beat, Jobs, OEE, and Print Beat services will require a <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>Productivity Power Pack subscription</a> starting August 4.",
      partialProductivitySubscribePreEnforcement_Desc: "Data from unsubscribed devices can be extracted before August.",
      partialProductivitySubscribePostEnforcement_Title: "Not all of your Indigo devices are subscribed to the Productivity Power Pack ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "Unsubscribed devices may limit your PrintOS experience (Print Beat, Jobs, OEE, Dashboards, ...)",
      goToMarket_Action: "Go to Marketplace",
      howToExtract_Action: "How to extract my data"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "German",
      "en-GB": "English (UK)",
      "en-US": "English (US)",
      "es-ES": "Spanish",
      "fr-FR": "French",
      "it-IT": "Italian",
      "ja-JP": "Japanese",
      "ko-KO": "Korean",
      "pt-PT": "Portuguese",
      "tr-TR": "Turkish",
      "zh-HANS": "Chinese (Simplified)",
      "ru-RU": "Russian",
      "PartialTranslation": "Partial translations",
    },
    modal: {
      ok: "Ok",
      cancel: "Cancel",
    },
    combo: {
      noItems: "No matches",
    },
    nps: {
      question: "Hi {0}. How likely are you to recommend PrintOS to a colleague?",
      // In case we can't get user's display name
      questionNameless: "How likely are you to recommend PrintOS to a colleague?",
      notLikely: "Not at all likely",
      likely: "Extremely likely",
      send: "Send Feedback",
      response: {
        detractor: "{0}, what one thing can we do to improve your PrintOS experience? We read every comment.",
        detractorNameless: "What one thing can we do to improve your PrintOS experience? We read every comment.",
        passive: "{0}, tell us how we can make your PrintOS experience even better. We read every comment.",
        passiveNameless: "Tell us how we can make your PrintOS experience even better. We read every comment.",
        promoter: "{0}, we're thrilled that you enjoy using PrintOS! Please tell us why. We read every comment.",
        promoterNameless: "We're thrilled that you enjoy using PrintOS! Please tell us why. We read every comment.",
      },
      introMorning: "Good morning {0}, I'm Jon, the Customer Success Manager for PrintOS.",
      introMorningNameless: "Good morning, I'm Jon, the Customer Success Manager for PrintOS.",
      introAfternoon: "Good afternoon {0}, I'm Jon, the Customer Success Manager for PrintOS.",
      introAfternoonNameless: "Good afternoon, I'm Jon, the Customer Success Manager for PrintOS.",
      introEvening: "Good evening {0}, I'm Jon, the Customer Success Manager for PrintOS.",
      introEveningNameless: "Good evening, I'm Jon, the Customer Success Manager for PrintOS.",
      intro2: "Please help me understand your PrintOS experience by answering this question:",
      intro3: "How likely are you to recommend PrintOS to a colleague?",
      detractorResponse: "Thank you for your response, {0}!  We value both positive and critical feedback.",
      detractorResponseNameless: "Thank you for your response!  We value both positive and critical feedback.",
      promoterResponse: "Thank you {0}!  It's great to hear that you're a fan of PrintOS.  Your feedback can still help us deliver the best possible experience.",
      promoterResponseNameless: "Thank you!  It's great to hear that you're a fan of PrintOS.  Your feedback can still help us deliver the best possible experience.",
      response2: "Please choose an application and tell us how we can improve PrintOS for you.",
      response3: "All comments are reviewed by the Customer Success team.  We might reach out to you to better understand your feedback.",
      feedbackPlaceholder: "You can improve PrintOS by...",
      application: "Application",
      noApplication: "PrintOS - General Feedback"
    },
    subscription: {
      title: "Subscription",
      subscribe: "Subscribe now!",
      noticeSingular: "Your {0} subscription expires in {1} day.",
      notice: "Your {0} subscription expires in {1} days.",
    },
    promotion: {
      label: "Promotion",
      title: "Promotional Period Notice",
      notice: "You are in a promotional period for this application.",
    },
    trial: {
      label: "Trial Expires Soon",
      title: "Trial Period",
      noticeSingular: "{0} is in a trial period. Your trial expires in {1} day.",
      notice: "{0} is in a trial period. Your trial expires in {1} days.",
    },
    subscriptionExpired: {
      label: "Subscription Expired",
      title: "Subscription Expired",
      notice: "Your subscription for {0} has expired.  After a short grace period, you will no longer be able to access this functionality.",
    },
    trialExpired: {
      label: "Trial Expired",
      title: "Trial Period Expired",
      notice: "Your trial period for {0} has expired.  After a short grace period, you will no longer be able to access this functionality.",
    },
    hpWarning: "{0}\nYou are an HP Inc. representative in a customer organization.  Please be careful.",
    role: {
      HP_Operation: "HP Operation",
      HP_Sales_and_Marketing: "HP Customer Facing",
      SystemRoleGenesis_Admin: "PrintOS Service Admin",
      SystemRoleGenesis_Support: "HP Inc. Admin",
      SystemRoleGenesis_R_AND_D: "Genesis R&D",
      CE_Level_1: "CE Level 1",
      CE_Level_2: "CE Level 2",
      Application_Engineer: "Application Engineer",
      Ramp_Up_Engineer: "Ramp Up Engineer",
      Support_Engineer: "Support Engineer",
      Remote_Support_Engineer: "HP Support Engineer",
      Specialist: "Specialist",
      Certification_Centers: "Certification Centers",
      Supplies_and_Media_Personnel: "Supplies and Media Personnel",
      Supplies_and_Media_Admin: "Supplies and Media Admin",
      HP_Service: "HP Service",
      HP_Training: "HP Training",
      Admin: "Administrator",
      Pre_Press_Operator: "User",
      Press_Operator: "Operator",
      Dashboard: "Dashboard",
      Channel_Sales_and_Marketing: "Channel Sales and Marketing",
      Channel_Operation: "Channel Operation",
      Channel_CE_Level_1: "Channel CE Level 1",
      Channel_CE_Level_2: "Channel CE Level 2",
      HP_Read_Only: "HP Read Only",
      Reseller_Manager: "Reseller Manager",
      Business_Partner_Manager: "Business Partner Manager",
      Call_Center: "Call Center",
      Field_Engineer: "Field Engineer",
      ThreeD_Business_Manager: "3D Business Manager",
      HPInPsp: "HP in PSP",
      ChannelInPsp: "Channel in PSP",
      GenericAdmin: "Administrator",
      GenericUser1: "User Level 1",
      GenericUser2: "User Level 2",
      Generic_Read_Only: "Read Only",
      ThreeD_Care_Center: "3D Care Center",
      ThreeD_Cost_Calculator: "3D Costing",
      Composer_External: "Limited Access - Composer",
      SIM_External: "Limited Access - Supplies Inventory Manager",
      Multiple: "Multiple Roles"
    },
    inlineAlerts: {
      Http_429_Error: "High traffic",
      Http_429_Description: "The service is experiencing abnormal loads right now.  Some functionality may be temporarily unavailable.  Refresh the page to try again",
      Http_429_Action: "Refresh",
      NewSubscription: "New Subscription - {0}",
      NewSubscriptionDescription: "Your organization has a new subscription",
      NewSubscriptionAction: "Learn more",
      SubscriptionExpired: "Subscription Expired - {0}",
      SubscriptionExpiredDescription: "Your subscription expired on {0}",
      SubscriptionExpiredAction: "View Subscription",
      Subscription30DayWarning: "Subscription Will Expire - {0}",
      Subscription30DayWarningDescription: "Your subscription will expire in {0} days on {1}",
      Subscription30DayWarningAction: "View Subscription",
      Subscription15DayWarning: "Subscription Expires Soon - {0}",
      Subscription15DayWarningDescription: "Your subscription will expire in {0} days on {1}",
      Subscription15DayWarningAction: "View Subscription",
      JoinOrgRequestAccepted: "Join Organization Request Accepted",
      JoinOrgRequestAcceptedDescription: "You have been granted access to <b>{0}</b>",
      JoinOrgRequestSwitch: "Open organization",
      JoinOrgRequestDenied: "Join Organization Request Denied",
      JoinOrgRequestDeniedDescription: "The administrator denied your request to join <b>{0}</b>",
      NonHPContext: "Open non-hp context window",
      NonHPContextDescription: "Context: {0}",
      CloseContext: "Close Context"
    },
    ui: {
      Confirm: "Confirm",
      Notify: "Notification",
      OpenImage: "Open Image File",
      Dismiss: "Dismiss",
      CheckingContext: "Checking context...",
      LoadingContext: "Restoring {0}..."
    }
  }
};
